import { render } from "./UpdateDataTable.vue?vue&type=template&id=29354c51&scoped=true"
import script from "./UpdateDataTable.vue?vue&type=script&lang=js"
export * from "./UpdateDataTable.vue?vue&type=script&lang=js"

import "./UpdateDataTable.vue?vue&type=style&index=0&id=29354c51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29354c51"]])

export default __exports__